// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App_title__YS7Xx {
  color: var(--text);
  font-size: 2.25rem;
  font-weight: 700;
  letter-spacing: -0.03em;
  margin: 0;
}

.App_subtitle__58P5V {
  color: var(--text-secondary);
  font-size: 0.875rem;
}

.App_sectionTitle__ROHEV {
  color: var(--text);
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: -0.0625rem;
}

@media (max-width: 575.98px) {
  .App_title__YS7Xx {
    font-size: 2.25rem;
  }

  .App_sectionTitle__ROHEV {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".title {\n  color: var(--text);\n  font-size: 2.25rem;\n  font-weight: 700;\n  letter-spacing: -0.03em;\n  margin: 0;\n}\n\n.subtitle {\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n}\n\n.sectionTitle {\n  color: var(--text);\n  font-size: 1.5rem;\n  font-weight: 600;\n  letter-spacing: -0.0625rem;\n}\n\n@media (max-width: 575.98px) {\n  .title {\n    font-size: 2.25rem;\n  }\n\n  .sectionTitle {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `App_title__YS7Xx`,
	"subtitle": `App_subtitle__58P5V`,
	"sectionTitle": `App_sectionTitle__ROHEV`
};
export default ___CSS_LOADER_EXPORT___;
